// extracted by mini-css-extract-plugin
module.exports = {"historyCompressionCompletes":"HistoryCompressionCompletes_historyCompressionCompletes__jSgbx","commonCard":"HistoryCompressionCompletes_commonCard__-Squl"};